// extracted by mini-css-extract-plugin
export default {"whatsappScreen":"_3vElu","cardWrapper":"_3Ancb","openWhatsappButton":"_2FZ7T","externalIcon":"_37C6C"};